import 'core-js/modules/es.array.map';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.string.split';
import _createForOfIteratorHelper from '/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper';
import _classCallCheck from '/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createClass';
import _createSuper from '/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createSuper';
import _inherits from '/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/inherits';
/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module font/fontfamily/fontfamilyui
 */
import { Plugin } from 'ckeditor5/src/core';
import { Collection } from 'ckeditor5/src/utils';
import {
    Model,
    createDropdown,
    addListToDropdown
} from 'ckeditor5/src/ui';
import { normalizeOptions } from './utils';
import { FONT_FAMILY } from '../utils';
import fontFamilyIcon from '../../theme/icons/font-family.svg';
/**
 * The font family UI plugin. It introduces the `'fontFamily'` dropdown.
 *
 * @extends module:core/plugin~Plugin
 */
var FontFamilyUI = /*#__PURE__*/
function (_Plugin) {
    _inherits(FontFamilyUI, _Plugin);
    var _super = _createSuper(FontFamilyUI);
    function FontFamilyUI() {
        _classCallCheck(this, FontFamilyUI);
        return _super.apply(this, arguments);
    }
    _createClass(FontFamilyUI, [
        {
            key: 'init',
            /**
     * @inheritDoc
     */
            value: function init() {
                var _this = this;
                var editor = this.editor;
                var t = editor.t;
                var options = this._getLocalizedOptions();
                var command = editor.commands.get(FONT_FAMILY);
                // Register UI component.
                editor.ui.componentFactory.add(FONT_FAMILY, function (locale) {
                    var dropdownView = createDropdown(locale);
                    addListToDropdown(dropdownView, _prepareListOptions(options, command));
                    dropdownView.buttonView.set({
                        label: t('Police'),
                        icon: fontFamilyIcon,
                        tooltip: true
                    });
                    dropdownView.extendTemplate({ attributes: { class: 'ck-font-family-dropdown' } });
                    dropdownView.bind('isEnabled').to(command);
                    // Execute command when an item from the dropdown is selected.
                    _this.listenTo(dropdownView, 'execute', function (evt) {
                        editor.execute(evt.source.commandName, { value: evt.source.commandParam });
                        editor.editing.view.focus();
                    });
                    return dropdownView;
                });
            }    /**
     * Returns options as defined in `config.fontFamily.options` but processed to account for
     * editor localization, i.e. to display {@link module:font/fontfamily~FontFamilyOption}
     * in the correct language.
     *
     * Note: The reason behind this method is that there is no way to use {@link module:utils/locale~Locale#t}
     * when the user configuration is defined because the editor does not exist yet.
     *
     * @private
     * @returns {Array.<module:font/fontfamily~FontFamilyOption>}.
     */
        },
        {
            key: '_getLocalizedOptions',
            value: function _getLocalizedOptions() {
                var editor = this.editor;
                var t = editor.t;
                var options = normalizeOptions(editor.config.get(FONT_FAMILY).options);
                return options.map(function (option) {
                    // The only title to localize is "Default" others are font names.
                    if (option.title === 'Default') {
                        option.title = t('Par défaut');
                    }
                    return option;
                });
            }
        }
    ], [{
            key: 'pluginName',
            /**
     * @inheritDoc
     */
            get: function get() {
                return 'FontFamilyUI';
            }
        }]);
    return FontFamilyUI;
}(Plugin);
// Prepares FontFamily dropdown items.
// @private
// @param {Array.<module:font/fontsize~FontSizeOption>} options
// @param {module:font/fontsize/fontsizecommand~FontSizeCommand} command
export {
    FontFamilyUI as default
};
function _prepareListOptions(options, command) {
    var itemDefinitions = new Collection();
    // Create dropdown items.
    var _iterator = _createForOfIteratorHelper(options), _step;
    try {
        var _loop = function _loop() {
            var option = _step.value;
            var def = {
                type: 'button',
                model: new Model({
                    commandName: FONT_FAMILY,
                    commandParam: option.model,
                    label: option.title,
                    withText: true
                })
            };
            def.model.bind('isOn').to(command, 'value', function (value) {
                // "Default" or check in strict font-family converters mode.
                if (value === option.model) {
                    return true;
                }
                if (!value || !option.model) {
                    return false;
                }
                return value.split(',')[0].replace(/'/g, '').toLowerCase() === option.model.toLowerCase();
            });
            // Try to set a dropdown list item style.
            if (option.view && option.view.styles) {
                def.model.set('labelStyle', 'font-family: '.concat(option.view.styles['font-family']));
            }
            itemDefinitions.add(def);
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally {
        _iterator.f();
    }
    return itemDefinitions;
}